<template>
  <div class="checkbox-group" >
    <slot></slot>
  </div>
</template>
<script>
import Emitter from '../emitter';
export default {
  name: 'MyCheckboxGroup',
  componentName: 'MyCheckboxGroup',
  mixins: [Emitter],
  props: {
    value: {}
  }
}
</script>
